import React from 'react';
import Dialog from '../../components/Dialog/Dialog';
import styles from './Ignore.module.less';
import Btn from '../../components/Btn/Btn';
import { Link } from 'react-router-dom';
import { CONTEXT } from '../../config';
import { PCStoreJsBridge } from '../../nativeapi';
import Toast from '../../components/Toast/Toast';
import { logNative } from '../../utils/utils';
import nodata from '../../static/collect_blank.svg';
import { logging, logPostInfo } from '../../actions/log';
import { createSelector } from 'reselect';
import { useDispatch, useSelector } from 'react-redux';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

export default ({ handleClose = () => {}, data }) => {
  const logInfoData = useSelector(selectLogInfo);
  const dispatch = useDispatch();

  const handleIgnoreForever = soft => () => {
    dispatch(
      logging({
        category: 'C',
        action: 'Update_Ignore_All',
        label: '',
        param2: {
          source: 'Update',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          softtype: soft.androidType,
          softid: soft.androidType === '1' ? soft.packageName : soft.softID || soft.softId,
        },
      }),
    );
    PCStoreJsBridge.ignoreSoftUpdate(soft, true, true)
      .then(ret => {
        if (ret.code === 0) {
          PCStoreJsBridge.getAndroidPCUpdateSoft();
          Toast.success({
            content: <div className={styles.toast}>忽略该软件所有版本，设置成功</div>,
            className: styles.toast_img,
          });
        } else {
          Toast.error({
            content: `忽略该软件所有版本，设置失败`,
          });
        }
      })
      .catch(err => {
        logNative(`忽略该软件所有版本，设置失败${err}`);
        Toast.error({
          content: `忽略该软件所有版本，设置失败`,
        });
      });
  };

  const handleResumeUpgrade = soft => () => {
    dispatch(
      logging({
        category: 'C',
        action: 'Update_Recover',
        label: '',
        param2: {
          source: 'Update',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          softtype: soft.androidType,
          softid: soft.androidType === '1' ? soft.packageName : soft.softID || soft.softId,
        },
      }),
    );
    PCStoreJsBridge.ignoreSoftUpdate(soft, false, false)
      .then(ret => {
        if (ret.code === 0) {
          PCStoreJsBridge.getAndroidPCUpdateSoft();
          Toast.success({
            content: `恢复提醒成功`,
          });
        } else {
          Toast.error({
            content: `恢复提醒失败，请稍后再试`,
          });
        }
      })
      .catch(err => {
        logNative(`忽恢复提醒失败，请稍后再试${err}`);
        Toast.error({
          content: `恢复提醒失败，请稍后再试`,
        });
      });
  };
  return (
    <Dialog
      title="管理已忽略软件"
      handleClose={handleClose}
      maskStyle={styles.mask}
      containerStyle={styles.container_ignore}
    >
      <div className={styles.soft_list}>
        {data.map((item, index) => (
          <div className={styles.soft} key={`${index}_${item.softID || item.packageName}`}>
            <div className={styles.soft_icon}>
              <img className={styles.soft_icon_img} src={item.logoFile} alt="" />
            </div>
            <div className={styles.soft_info}>
              <Link
                to={
                  item.androidType !== '1'
                    ? `${CONTEXT}/detail/soft/${item.softID || ''}/{}`
                    : `${CONTEXT}/adetail/${item.packageName || ''}/${
                        item.versionCode
                      }/${item.bizInfo || '{}'}`
                }
              >
                <div className={styles.soft_name} title={item.softName}>
                  {item.softName}
                </div>
              </Link>

              <div
                className={styles.soft_desc}
                title={item.introduction || item.whatsNew}
                dangerouslySetInnerHTML={{ __html: item.introduction || item.whatsNew }}
              />
            </div>
            <div className={styles.soft_version}>
              已忽略版本：{item.permanentIgnore ? '所有版本' : item.ignoredVersion}
            </div>

            <div className={styles.soft_ignore}>
              {!item.permanentIgnore && <div onClick={handleIgnoreForever(item)}>忽略所有版本</div>}
            </div>

            <div className={styles.soft_reminder}>
              <Btn className={styles.btn} handleClick={handleResumeUpgrade(item)}>
                恢复升级
              </Btn>
            </div>
          </div>
        ))}
        {(!data || data.length === 0) && (
          <div className={styles.blank}>
            <img src={nodata} className={styles.blank_img} />
            <div className={styles.blank_text}>暂无已忽略更新软件</div>
          </div>
        )}
      </div>
      {/* <div className={styles.soft_all_oper}>
        <Btn className={styles.btn_all} primary>
          全部恢复
        </Btn>
      </div> */}
    </Dialog>
  );
};
